// Vendors
import styled from 'styled-components';
import { COBRANDED_LIGHT_REGULAR_BASE_STYLES } from '@openbank/ziniaweb-ui-components';
// Utilities
import { convertPxsToRems } from '@openbank/cf-ui-framework';

const GAP_VERTICAL = 230;

const IframeComponentStyled = styled.iframe<{ frameGap: number }>`
  border: none;
  height: calc(100vh - ${convertPxsToRems({ pixels: GAP_VERTICAL, base: 16 })}) !important;
  width: 100%;

  ${COBRANDED_LIGHT_REGULAR_BASE_STYLES.MEDIA_QUERIES.mobileAndTablet} {
    height: calc(
      100vh - ${({ frameGap }) => convertPxsToRems({ pixels: frameGap, base: 16 })}
    ) !important;
  }
`;
IframeComponentStyled.displayName = 'IframeComponentStyled';

export { IframeComponentStyled };
